import groq from 'groq';
import { BLOG as BLOG_ROUTE } from 'lib/constants/routes';

export const RICH_TEXT = groq`
  _key,
  _type,
  level,
  listItem,
  children,
  style,
  markDefs[]{
    ...,
    _type == "internalLink" => {
      "slug": "${BLOG_ROUTE}/" +@.reference->slug.current
    },
    _type == "timeline_pageFootnoteAnnotation" => {
      "pageFootnotes": *[_type == "timeline_pageFootnote" && _id in ^.pageFootnote[]._ref] {
         name,
         content
      }
    }
  }
`;
